export default "__VITE_ASSET__BhYHFfQP__"